import React, {useCallback} from 'react';

import {Skeleton} from 'src/components/skeleton';

import ComboBox, {ComboboxItem, DefaultItem} from '@pb/kit-component-combo-box';
import Label from '@pb/kit-component-label';


import {AdminRoleSelectSkeleton} from './admin-role-select-skeleton';

import type {ProfileRecord} from 'src/openapi/admin/models/ProfileRecord';

type Props = {
    isLoading: boolean,
    disabled?: boolean,
    role: ProfileRecord | null,
    roles: ProfileRecord[] | null,
    changeRole: (role: ProfileRecord | null) => void,
};

export const AdminRoleSelect = ({isLoading, disabled, role, roles, changeRole}: Props) => {
    const onChange = useCallback((roleId: number) => {
        if (roles) {
            const newRole = roles.find(({profileId}) => profileId === roleId);
            changeRole(newRole || null);
        }
    }, [roles, changeRole]);

    return (
        <Skeleton shown={isLoading} view={<AdminRoleSelectSkeleton/>}>
            <div style={{width: 400}}>
                <Label>Admin Role</Label>
                {roles ? (
                    <ComboBox disabled={disabled} value={role?.profileId || -1} onChange={onChange}>
                        {[
                            <DefaultItem
                                key="None"
                                caption="None"
                                value={-1}
                            />,
                            ...roles.map(({profileId, profileName}) => (
                                <ComboboxItem key={profileId} value={profileId} caption={profileName}/>
                            )),
                        ]}
                    </ComboBox>
                ) : null}
            </div>
        </Skeleton>
    );
};
